import { ITextureStyle } from "../../../../../../../base/domain/drawing";
import { ITexturedShapeDrawableObject } from "../../../../../../domain/editableFormat/objects";
import { ITexturedShapeDrawableObjectBean } from "../../../beans/objects";
import { IntegerTranslator } from "../../values";

export class TextureStyleTranslator {
  from(bean: ITexturedShapeDrawableObjectBean): ITextureStyle {
    return {
      kind: this.integer.from(bean["@texture"]),
    };
  }

  to(o: ITexturedShapeDrawableObject) {
    return {
      texture: this.integer.to(o.textureStyle.kind),
    };
  }
 
  private readonly integer = new IntegerTranslator();
}
